export default __webpack_public_path__ + "locales/vi/SMTPSettings.json?hash=def9a616d1456469df7b0f0f526b20c7";